import { Tile } from "core/tiles";
export class TileWithElevation extends Tile {
    constructor(x, y, levelOfDetail, data = null, metrics) {
        super(x, y, levelOfDetail, data, metrics);
        this._surface = null;
        this._gridSize = null;
    }
    get gridSize() {
        return this._gridSize;
    }
    set gridSize(v) {
        this._gridSize = v;
    }
    get surface() {
        return this._surface;
    }
    set surface(s) {
        this._surface = s;
    }
}
//# sourceMappingURL=map.tile.js.map